module.exports = __webpack_public_path__ + "static/media/trans.f0447a46.png";